import React from 'react'
import cn from 'classnames'

import NumberPad from '../../NumberPad'
import Button from '../../Button'

import modalStyles from '../../QuantityEntryModal.module.scss'
import styles from './SplitOrderNumberPad.module.scss'

const SplitOrderNumberPad = ({ title, value, valueAccessory, confirmButtonText, valid, onInput, onCancel, onConfirm, className }) => {
  const classNames = cn(styles.splitOrderNumberPad, modalStyles.quantityEntryModal, className)
  let valueAccessoryElement = null

  if (valueAccessory !== null) {
    valueAccessoryElement = <span className={styles.total}>{valueAccessory}</span>
  }

  return (
    <div className={classNames}>
      <div className={modalStyles.overlay}></div>
      <div className={modalStyles.content}>
        <div className={modalStyles.body}>
          <div className={modalStyles.title}><div className={modalStyles.titleMessage}>{title}</div></div>
          <div className={modalStyles.numberPadGrid}>
            <div className={modalStyles.displayQuantity}>{value}{valueAccessoryElement}</div>
            <NumberPad onTapButton={onInput} />
          </div>
          <div className={modalStyles.rightSidebar}>
            <Button disabled={!valid} className={modalStyles.confirmSetQuantity} onClick={onConfirm}>
              {confirmButtonText}
            </Button>
            <Button className={modalStyles.cancelButton} onClick={onCancel}>Cancel</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SplitOrderNumberPad
